import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  MatButtonToggleChange,
  MatButtonToggleModule,
} from '@angular/material/button-toggle';
import { whmcsCurrency } from '@app/core';
import { fadeInOutAnimation } from '@app/core/animations';
import { AuthState } from '@app/core/auth/states/auth.state';
import { LogEvent, SetEventProperties } from '@app/core/states/event-tracking.actions';
import { SkipToStep } from '@app/core/states/stepper.actions';
import { StepperComponent } from '@app/core/stepper/stepper.component';
import { TranslateModule } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { OfferComponent } from './offer/offer.component';

@Component({
  selector: 'rk-plan',
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.scss'],
  animations: [fadeInOutAnimation],
  imports: [
    StepperComponent,
    MatButtonToggleModule,
    OfferComponent,
    TranslateModule,
    AsyncPipe,
    CommonModule,
  ],
})
export class PlanComponent implements OnInit {
  @Select(AuthState.userCurrency)
  currency$: Observable<whmcsCurrency>;

  billing: string;

  constructor(private readonly store: Store) {}

  ngOnInit() {
    this.store.dispatch(new SkipToStep(2));

    this.billing = 'Monthly';

    // event tracking
    this.store.dispatch(
      new SetEventProperties({
        name: 'PageCreationPricing',
        component: 'Page',
      }),
    );
    this.store.dispatch(new LogEvent('Page Viewed'));
  }

  changeBilling(e: MatButtonToggleChange) {
    this.billing = e.value;

    // event tracking
    this.store.dispatch(
      new SetEventProperties({
        name: 'ButtonPricing' + this.billing,
        component: 'Button',
      }),
    );
    this.store.dispatch(new LogEvent('Button Clicked'));
  }
}
